import React, {useEffect, useMemo, useState} from 'react';
import styled from "styled-components";
import PageTitle from "../../components/PageTitle";
import Icn from "../../components/Icn";
import Tx from "../../components/Tx";
import Paper from "@mui/material/Paper";
import {api} from "../../maps/data";
import ALERT_MAP from "../../maps/alertMap";
import {colors} from "../../maps/colors";
import {useNavigate} from "react-router-dom";

const WrapperStyled = styled.div`

`;

const BoxesListStyled = styled.div`
    display: grid;
    grid-template-columns: 500px 500px;
    gap: 25px;
    height: 440px;
`;

const BoxTitleStyled = styled.div`
    padding: 10px 10px;
    font-size: 22px;
`;

const BoxContStyled = styled.div`
    padding: 10px 10px;
`;

const MoreInfoStyled = styled.div`
    padding: 10px 10px;
    position: absolute;
    bottom: 10px;
`;

const BoxItemStyled = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 10px;

    cursor: pointer;

    padding: 7px 0 7px 15px;
    margin-bottom: 10px;

    border-left: 6px solid;
    border-bottom-width: 2px;
    border-bottom-color: rgba(145, 158, 171, 0.2);

    &.INFO {
        border-color: ${colors.LIGHT_GREEN};
    }

    &.CRITICAL {
        border-color: ${colors.WARM_RED};
    }

    &.WARNING {
        border-color: ${colors.LIGHT_ORANGE};
    }

    &:hover {
        background: rgb(223 223 223);
    }
`;

const ImDashboardMain = () => {
    const navigate = useNavigate();

    const [dashboardData, s_dashboardData] = useState([]);

    const getDashboardData = async () => {
        api({
            type: "getAlertsByTypeAndCount",
            data: {
                statuses: ["ACTIVE"],
                eventTypes: ["SHELF_BOUNCER"],
                eventEntitys: ["ALERT"]
            }
        }).then(data => {
            s_dashboardData(data);
        }).catch(e => {
            console.error(e);
        });
    };

    useEffect(() => {
        getDashboardData();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            getDashboardData();
        }, 6000);
        return () => clearInterval(interval);
    }, []);

    const dataToShow = useMemo(() => {
        const memoData = [];
        dashboardData.forEach(dd => {
            let sevNum = 10;
            let sev = ALERT_MAP.severities.INFO;

            const isCrit = dd.severities.indexOf(ALERT_MAP.severities.CRITICAL) !== -1;
            const isWarn = dd.severities.indexOf(ALERT_MAP.severities.WARNING) !== -1;

            if (isWarn) {
                sevNum = 20;
                sev = ALERT_MAP.severities.WARNING;
            }
            if (isCrit) {
                sevNum = 30;
                sev = ALERT_MAP.severities.CRITICAL;
            }
            dd.sev = sev;
            dd.sevNum = sevNum;
            memoData.push(dd);
        });

        memoData.sort((a, b) => b.sevNum - a.sevNum);

        return memoData;
    }, [dashboardData]);

    const noIssues = dashboardData?.length === 0;

    return (
        <div style={{height: '100%', padding: 20, overflow: 'auto'}}>
            <PageTitle>
                <div style={{position: 'relative'}}>
                    <Icn>dashboardIcon</Icn> <Tx>menu.dashboard</Tx>
                </div>
            </PageTitle>
            <WrapperStyled>
                <BoxesListStyled>
                    <Paper elevation={3} style={{position: 'relative'}}>
                        <BoxTitleStyled>Issues</BoxTitleStyled>
                        <BoxContStyled>
                            {noIssues && (
                                <span>No issues</span>
                            )}
                            {!noIssues && (
                                dataToShow.map((item, index) => {
                                    return (
                                        <BoxItemStyled key={index} className={item.sev} onClick={() => {
                                            navigate(`/im-alerts?type=${item.subType}`);
                                        }}>
                                            <div>
                                                {ALERT_MAP.eventTypes?.[item.subType]?.title}
                                            </div>
                                            <div>
                                                {item.count}
                                            </div>
                                        </BoxItemStyled>
                                    );
                                })
                            )}
                        </BoxContStyled>
                        <MoreInfoStyled>
                            {/*<Link to={"/im-alerts"}>More info</Link>*/}
                        </MoreInfoStyled>
                    </Paper>
                    <Paper elevation={3} style={{position: 'relative'}}>
                        <BoxTitleStyled>Workers in store</BoxTitleStyled>
                        <BoxContStyled>
                            Bouncer 1
                        </BoxContStyled>
                        <MoreInfoStyled>
                            <a href="">More info</a>
                        </MoreInfoStyled>
                    </Paper>
                </BoxesListStyled>
            </WrapperStyled>
        </div>
    );
};

export default ImDashboardMain;